import React, { useState, useRef } from 'react';
import { Play, Pause, Volume2, Headphones, ArrowRight } from 'lucide-react';
interface AudioSectionProps {
  audioUrl?: string;
}
export function AudioSection({
  audioUrl
}: AudioSectionProps) {
  // Usamos el nuevo video para todas las páginas
  const finalAudioUrl = audioUrl || 'https://cdn.magicpatterns.com/uploads/eaSMAS83xQECGVdRN8TiAA/Video%20Project%206.mp4';
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };
  const handleTimeUpdate = () => {
    if (!audioRef.current) return;
    const current = audioRef.current.currentTime;
    const total = audioRef.current.duration || 0;
    setCurrentTime(current);
    setProgress(total ? current / total * 100 : 0);
  };
  const handleLoadedMetadata = () => {
    if (audioRef.current) setDuration(audioRef.current.duration);
  };
  const handleEnded = () => setIsPlaying(false);
  const handleSeek = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!audioRef.current) return;
    const val = Number(e.target.value);
    const time = val / 100 * (audioRef.current.duration || 0);
    audioRef.current.currentTime = time;
    setProgress(val);
  };
  const formatTime = (s: number) => {
    if (!s || isNaN(s)) return '0:00';
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec.toString().padStart(2, '0')}`;
  };
  return <section className="bg-slate-900 py-16 sm:py-20" data-id="element-6">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7">
        <div className="mx-auto max-w-2xl text-center mb-10" data-id="element-8">
          <div className="inline-flex items-center gap-2 rounded-full bg-blue-500/20 px-4 py-1.5 text-sm font-medium text-blue-300 ring-1 ring-inset ring-blue-400/30 mb-4" data-id="element-9">
            <Headphones className="w-4 h-4" data-id="element-10" />
            Incluido con tu compra
          </div>
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl font-serif mb-4" data-id="element-11">
            🎧 El Kit también incluye Audiolibro
          </h2>
          <p className="text-slate-300 text-lg" data-id="element-12">
            Escuchá una muestra ahora. Podés usarlo en el colectivo, antes de
            dormir o en cualquier momento que lo necesites.
          </p>
        </div>

        {/* Player card */}
        <div className="mx-auto max-w-xl mb-12" data-id="element-13">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 shadow-2xl" data-id="element-14">
            {/* Track info */}
            <div className="flex items-center gap-4 mb-6" data-id="element-15">
              <div className="w-14 h-14 rounded-xl bg-blue-600 flex items-center justify-center flex-shrink-0 shadow-lg shadow-blue-500/30" data-id="element-16">
                <Volume2 className="w-7 h-7 text-white" data-id="element-17" />
              </div>
              <div data-id="element-18">
                <p className="text-white font-bold text-lg font-serif leading-tight" data-id="element-19">
                  SOS Ansiedad — Audiolibro
                </p>
                <p className="text-slate-400 text-sm mt-0.5" data-id="element-20">
                  Muestra gratuita · Guía hacia la calma
                </p>
              </div>
            </div>

            {/* Progress bar */}
            <div className="mb-3" data-id="element-21">
              <input type="range" min={0} max={100} value={progress} onChange={handleSeek} className="w-full h-1.5 rounded-full appearance-none cursor-pointer accent-blue-400 bg-white/20" data-id="element-22" />
            </div>

            {/* Play button */}
            <div className="flex items-center justify-center mt-4" data-id="element-23">
              <button onClick={togglePlay} className="w-14 h-14 rounded-full bg-blue-600 hover:bg-blue-500 transition-colors flex items-center justify-center shadow-lg shadow-blue-500/30 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-slate-900" aria-label={isPlaying ? 'Pausar' : 'Reproducir'} data-id="element-24">
                {isPlaying ? <Pause className="w-6 h-6 text-white" data-id="element-25" /> : <Play className="w-6 h-6 text-white ml-0.5" data-id="element-26" />}
              </button>
            </div>

            {/* Hidden audio element */}
            <audio ref={audioRef} src={finalAudioUrl} onTimeUpdate={handleTimeUpdate} onLoadedMetadata={handleLoadedMetadata} onEnded={handleEnded} preload="metadata" data-id="element-27" />
          </div>

          <p className="text-center text-slate-500 text-sm mt-4 italic" data-id="element-28">
            Esta es solo una parte. El audiolibro completo viene incluido con tu
            compra.
          </p>
        </div>

        {/* CTA Button moved from Hero */}
        <div className="flex justify-center" data-id="element-29">
          <a href="#oferta-cta" onClick={e => {
          e.preventDefault();
          document.getElementById('oferta-cta')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }} className="inline-flex items-center justify-center rounded-lg font-bold transition-colors bg-blue-600 text-white hover:bg-blue-500 shadow-lg shadow-blue-500/30 h-16 px-12 text-xl w-full sm:w-auto transform hover:scale-105" data-id="element-30">
            QUIERO MI KIT SOS AHORA
            <ArrowRight className="ml-2 h-6 w-6" data-id="element-31" />
          </a>
        </div>
      </div>
    </section>;
}